var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPencil = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 14 15"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#3C3C43",
  strokeLinecap: "round",
  strokeOpacity: 0.6,
  strokeWidth: 1.25,
  d: "m8.836 3.523 2.157 2.133m.229-2.869.495.495a1.166 1.166 0 0 1 0 1.65l-6.555 6.554a1.2 1.2 0 0 1-.456.282l-2.403.801a.292.292 0 0 1-.369-.369l.801-2.403c.058-.172.154-.328.282-.456l6.555-6.554a1.167 1.167 0 0 1 1.65 0Z"
})));
export default SvgPencil;